const m = window.require("@ember/routing/router");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;